import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import Check from '../../SidePanel/RightPanel/PropertiesControllerCheck.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Number from '../../SidePanel/RightPanel/PropertiesControllerNumber.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import ButtonMakeFk from './PropertiesPaneButtonMakeFk.jsx'
import DataType from './PropertiesControllerDataType.jsx'
import DefVal from './PropertiesControllerDefVal.jsx'
import DfPrecision from './PropertiesControllerDfPrecision.jsx'
import Dgf from './PropertiesControllerDgf.jsx'
import Model from './ModelDf.mjs'

const PropertiesPaneDf = (props) => (
    <ComponentPropertiesPane
        buttons={<ButtonMakeFk />}

        controllers={
            <>
                <Check prop="isCdgDf" />
                <Dgf />
                <Text prop="dfUserCode" />
                <Text prop="dfName" />
                <Text prop="dfAlias" />
                <DataType />

                <Number
                    int
                    min={1}
                    prop="dfLen"
                />

                <DfPrecision />
                <Check prop="isPk" />
                <Check prop="isBk" />
                <Check prop="isNull" />
                <Check prop="isTcField" />
                <DefVal />
                <LongText prop="dfDesc" />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'ChgReferenceSingle',
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        {...props}
    />
)

export default PropertiesPaneDf
